import React from "react"
import { connect } from "react-redux"
import Panel from "../../components/clock-in/panel"

const hiddenLeft = {left: "-100%"}
const visible = {left: "0"}

const propsFromContext = {
  cash_balance: {
    clockInOutStyle: hiddenLeft,
    cashAmountStyle: hiddenLeft,
    cashBalanceStyle: visible
  },
  clock_in: {keypadButton: "Clock in"},
  clock_out: {keypadButton: "Clock in / out", showStats: true},
  new_user: {
    keypadButton: "Set Pin",
    clockInOutStyle: hiddenLeft,
    newUserStyle: visible
  },
  new_user_confirmation: {
    keypadButton: "Confirm Pin",
    keypadButtonClass: "green",
    clockInOutStyle: hiddenLeft,
    newUserStyle: visible
  },
  new_user_done: {
    clockInOutStyle: hiddenLeft,
    newUserStyle: hiddenLeft,
    newUserDoneStyle: visible
  },
  starting_cash: {
    clockInOutStyle: hiddenLeft,
    cashAmountStyle: visible
  },
  ending_cash: {
    clockInOutStyle: hiddenLeft,
    cashAmountStyle: visible
  },
  stats1: {
    clockInOutStyle: hiddenLeft,
    statsStyle: visible
  },
  stats2: {
    clockInOutStyle: hiddenLeft,
    statsStyle: visible,
    statsWithCancel: true
  }
}

const mapStateToProps = state => ({
  ...state.clockIn,
  ...propsFromContext[state.clockIn.context],
  isVisible: state.clockIn.context !== "hidden" && !state.clockIn.isCancelling
})

const mapDispatchToProps = dispatch => ({
  onChangeNewUserImage: (image) => dispatch({type: "CLOCK_IN.NEW_USER_CHANGED", payload: {image}}),
  onChangeNewUserFirstName: (e) => dispatch({type: "CLOCK_IN.NEW_USER_CHANGED", payload: {firstName: e.target.value}}),
  onChangeNewUserLastName: (e) => dispatch({type: "CLOCK_IN.NEW_USER_CHANGED", payload: {lastName: e.target.value}}),
  onClickPanel: (e) => {if (e.target.parentElement === e.currentTarget) {
    e.preventDefault()
    dispatch({type: "CLOCK_IN.START_CANCEL"})
  }},
  onClickBack: () => dispatch({type: "CLOCK_IN.BACK_CLICKED"}),
  onClickCancel: (e) => dispatch({type: "CLOCK_IN.START_CANCEL"}),
  onConfirmClockOut: () => {
    dispatch({type: "CLOCK_IN.START_CANCEL"})
    dispatch({type: "CLOCK_IN.CONFIRM_CLOCK_OUT"})
  },
  onClickNewUser: () => dispatch({type: "CLOCK_IN.NEW_USER"}),
  onClickPinNumber: (number, e) => {
    e.preventDefault()
    dispatch({type: "CLOCK_IN.PIN_NUMBER_CLICKED", payload: {number}})
  },
  onClickStats: () => dispatch({type: "CLOCK_IN.GET_STATS"}),
  onConfirmNewUser: () => dispatch({type: "CLOCK_IN.CONFIRM_NEW_USER"}),
  onDeletePinNumber: (e) => {
    e.preventDefault()
    dispatch({type: "CLOCK_IN.PIN_NUMBER_DELETE"})
  },
  onNewUserDone: () => dispatch({type: "CLOCK_IN.START_CANCEL"}),
  onSetNewUserPin: () => dispatch({type: "CLOCK_IN.SET_NEW_USER_PIN"}),
  onCashAmountDone: (cashAmount, context) => dispatch({type: "CLOCK_IN.CASH_DONE", payload: {cashAmount, context}}),
  onSubmitPin: () => dispatch({type: "CLOCK_IN.SUBMIT"}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Panel)
